import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import CharacterCount from "editor/components/CharacterCount";
import Sidekick from "components/library/Sidekick";
import Textarea from "react-textarea-autosize";
import styles from "./HeadlineInput.css";

import {
  HEADLINE_FIRST_WARNING,
  HEADLINE_SECOND_WARNING,
} from "config/constants/editor";

export default class HeadlineInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = { charCountVisible: false };
    this.handleFocus = this._handleFocus.bind(this);
    this.handleBlur = this._handleBlur.bind(this);
    this.onKeyDown = this._onKeyDown.bind(this);
  }

  _handleFocus() {
    this.setState({ charCountVisible: true });
  }

  _handleBlur() {
    this.setState({ charCountVisible: false });
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  }

  _onKeyDown(event) {
    if (event.keyCode == 13) {
      event.preventDefault();
    }
  }

  render() {
    const inputClass = classNames(styles.input, {
      [styles.warning]: this.props.value.length >= HEADLINE_SECOND_WARNING,
    });

    return (
      <div
        className={classNames(styles.root, {
          [styles.subhead]: this.props.displayAs === "subhead",
        })}
      >
        <Textarea
          className={inputClass}
          name="headline"
          value={this.props.value}
          placeholder="Type your headline"
          onChange={this.props.onChange}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onKeyDown={this.onKeyDown}
          disabled={this.props.isDisabled}
          data-cy="headlineInput"
          onClick={this.props.onClick}
        />
        <div className={styles.characterCount}>
          <CharacterCount
            visible={this.state.charCountVisible}
            count={this.props.value.length}
            warningLength={HEADLINE_FIRST_WARNING}
          />
        </div>
        {this.props.error && (
          <Sidekick hasError={true} title={this.props.error.title}>
            {this.props.error.message}
          </Sidekick>
        )}
      </div>
    );
  }
}

HeadlineInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  displayAs: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
};
